export class Pomodoro {
  public description: any;
  public category: any;
  public id: any;
  public count = 1;
  public doneTime: any;
  // tslint:disable-next-line:variable-name
  public ended_at: any;
  public isEdit = false;
  public done = false;
  // public category_id = 2;
  // tslint:disable-next-line:variable-name
  public user_id = localStorage.getItem('userId');
  // tslint:disable-next-line:variable-name
  public created_at: any;
  // tslint:disable-next-line:variable-name
  public time_length: any;
}
